import React from 'react';
import { Route as ReactDOMRoute, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { LOGIN_PATH, ROOT_PATH } from '../../../constants/routes';
import history from '../../../utils/history';
import { usePortalAccess } from '../../../hooks/usePortalAccess';
import { portalLanding } from '../../../services/PortalAccess';

function Route({ isPrivate, component: Component, ...rest }) {
  const user = useSelector((state) => state.user.user);
  const access = usePortalAccess();
  const loading = useSelector((state) => state.user.isLoading || state.user.isInitialLoading);

  const currentLocation =
    history.location.pathname && history.location.pathname !== LOGIN_PATH
      ? history.location.pathname
      : ROOT_PATH;

  return (
    <ReactDOMRoute
      {...rest}
      render={({ location, match }) => {
        if (isPrivate && loading) return <div role="status">Loading...</div>;
        if (!user && isPrivate) {
          return (
            <Redirect
              to={{
                pathname: LOGIN_PATH,
                state: { from: currentLocation },
              }}
            />
          );
        }
        if (isPrivate) {
          if (!access.dispatcher && !access.driver) return <div role="alert">Access unavailable. Your profile does not report DOP staff permission. Driver-only portal access is disabled.</div>;
          const selfRoute = match.path === '/drivers/:id' && match.params.id === access.id;
          if (access.driver && location.pathname !== '/history' && !selfRoute) {
            return <Redirect to={portalLanding(user)} />;
          }
        }
        return <Component />;
      }}
    />
  );
}

Route.propTypes = {
  isPrivate: PropTypes.bool,
  component: PropTypes.func.isRequired,
};

Route.defaultProps = {
  isPrivate: false,
};

export default Route;
